import { message } from 'antd';
import axios from 'axios';
import {
  getRefreshIsLoading,
  onRefreshTokenAsync,
  onShowLoginModal,
  setRefreshLoading,
} from '@/components/UserModal/utils';
import customLocalStorgeEventListener from '@/components/UserModal/utils/timeout';
import { fetchError, getAPIPrefix, getLocalToken, showLoginModal } from '@/utils';

const instance = axios.create({
  // baseURL: '/api',
  // headers: { ['x-token']: 'eyJ1aWQiOjMwNjksInVuYW1lIjoi5p2O5Lqa55S3Iiwia' },
});

// 添加请求拦截器
instance.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    // const access_token = get_access_token();
    const access_token = getLocalToken();

    if (access_token) {
      config.headers.Authorization = access_token;
    } else {
      // fetchError(200002); // 强制登录
    }

    // 参数里有token的话 使用参数的token
    if (config?.data?.token) {
      config.headers.Authorization = config.data.token;
    }

    // todo 优化
    const url = getAPIPrefix(config?.url);
    return { ...config, url };
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  },
);

let retryRequests: any = [];

let isRefreshing = false;
export function updateRefreshing(bool: boolean) {
  isRefreshing = bool;
}

// 添加响应拦截器
instance.interceptors.response.use(
  function (response) {
    // fetchError(200007);
    return response.data;
  },
  function (error) {
    const { response } = error;
    const { skipErrorHandler, status } = error.config;
    const skipError = skipErrorHandler && status == response.status; //需要跳过弹窗

    // 没有响应，服务器网络超时
    if (!response) {
      return Promise.reject(error);
    }
    const { code, msg } = response.data;
    const { status: responseStatus } = response;

    // const refreLoading1 = getRefreshIsLoading();
    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        retryRequests.push(() => {
          resolve(instance.request(response.config));
        });
      });
    }

    if (code === 100003) {
      updateRefreshing(true);
      return new Promise((resolve, reject) => {
        onRefreshTokenAsync()
          .then((data) => {
            if (data?.access_token && data?.refresh_token) {
              retryRequests.forEach((cb) => cb());
              retryRequests = [];
              return resolve(instance.request(response.config));
            } else {
              if (!skipError) {
                fetchError(code || responseStatus); // 异常code 处理
              }
              return reject(error);
            }
          })
          .catch(() => {
            // showLoginModal();
            // message.error(msg);
            fetchError(code || responseStatus); // 异常code 处理
            return reject(error);
          })
          .finally(() => {
            updateRefreshing(false);
            setRefreshLoading(false);
          });
      });
    }

    const token = getLocalToken();
    const resToken = response.config.headers.Authorization;
    if (token && resToken && token !== resToken && !error?.config?.url.includes('/setToken')) {
      console.log('前后token不一致 重新发起请求');
      return instance.request(response.config);
    }

    if (!skipError) {
      fetchError(code || responseStatus); // 异常code 处理
    }
    return Promise.reject(error);
  },
);

export default instance;
